import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Bug } from 'lucide-react';
import { useDebugStore } from '../../stores/debugStore';

interface DebugButtonProps {
  size?: 'small' | 'medium' | 'large';
}

export const DebugButton: React.FC<DebugButtonProps> = ({ size = 'small' }) => {
  const { toggleDebug } = useDebugStore();

  return (
    <Tooltip title="Open Debug Panel" arrow>
      <IconButton
        data-testid="debug-panel-button"
        onClick={toggleDebug}
        size={size}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
          },
        }}
        aria-label="Open debug panel"
      >
        <Bug size={size === 'small' ? 16 : size === 'medium' ? 20 : 24} />
      </IconButton>
    </Tooltip>
  );
};
